module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_null_null.e040b03e.png";